import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {SchedulesChecklistModelService} from '../../../Models/Tasks/Checklists/schedules-checklist-model.service';
import {ScheduledChecklistStoreForm} from '../../../../Models/Tasks/Checklists/Schedules/scheduled-checklist-store.model';

@Injectable({
  providedIn: 'root'
})
export class SchedulesChecklistApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: SchedulesChecklistModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener las programaciones de los checklists y auditorias
   *
   */
  getSchedulesChecklist(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getModeloAsignaciones', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar una programación
   *
   */
  saveSchedule(form: ScheduledChecklistStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setModeloAsignacion', form).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Eliminar una programación
   *
   */
  deleteSchedule(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteModeloAsignacion', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Activar/Desactivar una programación
   *
   */
  toggleSchedule(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('toggleModeloAsignacion', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
